export const DATA_API = `${process.env.PUBLIC_URL}/data.json`;



// WEBPACK FOOTER //
// ./src/constants/index.js